import React from 'react';
import SectionLayout from './SectionLayout';

const Team: React.FC = () => {
  const teamMembers = [
    { name: 'Restu Ramadhika', position: 'Head of Business Development', img: '/tricipta/8.png' },
    { name: 'Samsu Rizal', position: 'Head of Programmer', img: '/tricipta/MasRizal.JPG' },
    { name: 'Yoan Jebar', position: 'Head of Technical Development', img: '/tricipta/1.png' },
    { name: 'Nurmansyah Chandra', position: 'Head of Quality Assurance', img: '/tricipta/MasNur.JPG' },
    { name: 'Dadan Suwandi', position: 'DevOps Engineer', img: '/tricipta/3.png' },
    { name: 'Wanda Irwansyah', position: 'Data Engineer', img: '/tricipta/2.png' },
    { name: 'Elang Bimantoro', position: 'Software Engineer', img: '/tricipta/MasElang.JPG' },
    { name: 'Mochamad Rifqi', position: 'Project Manager', img: '/tricipta/4.png' },
    { name: 'Faizal Aji', position: 'Software Engineer', img: '/tricipta/7.png' },
    { name: 'Aji Bagus', position: 'Software Engineer', img: '/tricipta/6.png' },
    { name: 'Arya Dwi Putra', position: 'Software Engineer', img: '/tricipta/9.png' },
    { name: 'Raihan Alip', position: 'Software Engineer', img: '/tricipta/Alip.jpg' },
    { name: 'Fatur Rachmat', position: 'Software Engineer', img: '/tricipta/Fatur.jpg' },
    { name: 'Galih Aditya', position: 'Software Engineer', img: '/tricipta/Galih.jpg' },

  ];

  return (
    <>
      <style>{`
        .team-section {
          padding-top: 80px;
          padding-bottom: 80px;
        }

        .team-grid-new {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 24px;
          margin-top: 60px;
          justify-items: stretch;
          max-width: 1400px;
          margin-left: auto;
          margin-right: auto;
        }

        .team-member-card {
          background: var(--card-2, rgba(255, 255, 255, 0.02));
          border: 2px solid var(--border, rgba(255, 255, 255, 0.08));
          border-radius: 20px;
          padding: 24px;
          text-align: center;
          width: 100%;
          min-height: 280px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .team-photo {
          width: 140px;
          height: 140px;
          border-radius: 50%;
          margin: 0 auto 16px;
          border: 3px solid var(--border-strong, rgba(255, 255, 255, 0.12));
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 48px;
          color: white;
          overflow: hidden;
        }

        .team-photo img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .team-name {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 8px;
          color: var(--text, #ffffff);
        }

        .team-position {
          font-size: 14px;
          color: var(--muted-2, rgba(255, 255, 255, 0.6));
        }

        @media (max-width: 1200px) {
          .team-grid-new {
            grid-template-columns: repeat(4, 1fr);
          }
        }

        @media (max-width: 900px) {
          .team-grid-new {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (max-width: 768px) {
          .team-section {
            padding: 80px 24px;
          }

          .team-grid-new {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }
        }

        @media (max-width: 480px) {
          .team-grid-new {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <SectionLayout id="team" maxWidth="2xl">
        <section 
          className="team-section"
        >
        <div className="section-header">
          <h2 className="section-title">Tim Kami</h2>
          <p className="section-description">
            Tim profesional yang berdedikasi untuk memberikan solusi terbaik bagi bisnis Anda.
          </p>
        </div>

        <div className="team-grid-new">
          {teamMembers.map((member, idx) => (
            <div key={idx} className="team-member-card">
              <div className="team-photo">
                <img src={member.img} alt={member.name} />
              </div>
              <div className="team-name">{member.name}</div>
              <div className="team-position">{member.position}</div>
            </div>
          ))}
        </div>
        </section>
      </SectionLayout>
    </>
  );
};

export default Team;

